module.exports = __webpack_public_path__ + "static/media/7.ed025ec4.jpg";